try {
    window.$ = window.jQuery = require("jquery");
    require("bootstrap-sass");
} catch (e) {}
require("slick-carousel");
window.Vue = require("vue");
Vue.use(require("vue-resource"));
window.validator = require("jquery-validation");
window.validate = require("./validate");
window.toastr = require("toastr");
window.Ladda = require("ladda");
require("spin.js");

var LazyLoad = require("vanilla-lazyload");
var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy",
    load_delay: 300, //adjust according to use case
});

myLazyLoad.update();
$(document).ready(function() {
    toastr.options = {
        closeButton: true,
        positionClass: "toast-top-right",
        timeOut: "5000",
        showDuration: "300",
        hideDuration: "300",
        tapToDismiss: false,
        preventDuplicates: true,
    };
});
$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

Vue.http.headers.common["X-CSRF-TOKEN"] = $('meta[name="csrf-token"]').attr(
    "content"
);

$("#testimonials").slick({
    arrows: true,
    prevArrow: '<a class="slick-prev"><i class="icon prev"></i ></a>',
    nextArrow: '<a class="slick-next"><i class="icon next"></i ></a>',
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
    responsive: [
        {
            breakpoint: 480,
            settings: {
                autoplay: true,
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});

$("#centerLogos").slick({
    speed: 500,
    fade: true,
    cssEase: "linear",
    responsive: [
        {
            breakpoint: 480,
            settings: {
                autoplay: true,
                arrows: false,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});

$("#mediaLogos").slick({
    speed: 500,
    fade: true,
    cssEase: "linear",
    responsive: [
        {
            breakpoint: 480,
            settings: {
                autoplay: true,
                arrows: false,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});

$(".page-scroll").bind("click", function(event) {
    var $anchor = $(this);
    $("html, body")
        .stop()
        .animate(
            {
                scrollTop: $($anchor.attr("href")).offset().top,
            },
            500
        );
    event.preventDefault();
});

var videoSrc = $("#successStory iframe").attr("src");

$("#successStory").on("show.bs.modal", function() {
    // on opening the modal
    // set the video to autostart
    $("#successStory iframe").attr("src", videoSrc + "?autoplay=1");
});

$("#successStory").on("hidden.bs.modal", function(e) {
    // on closing the modal
    // stop the video
    $("#successStory iframe").attr("src", null);
});

new Vue({
    el: "#tncAcceptId",
    data: {
        status: false,
    },
    methods: {
        tncAccepted: function(token) {
            this.$http.get("/consent/agree?token=" + token).then(
                (response) => {
                    this.status = response.body.status;
                },
                (response) => {
                    toastr["error"]("Something went wrong!", "Failed");
                }
            );
        },
    },
});

window.requestDemoSourceButton = "";
$(".requestDemoButton").click(function() {
    var buttonPos = $(this).data("buttonPosition");
    window.requestDemoSourceButton = buttonPos;
    // localStorage.setItem("requestDemoSourceButton", buttonPos);
    console.log(buttonPos);
});

var reqDemo = {
    data() {
        return {
            countryList: [],
            filterCountryList: [],
            countryFlagUrl: "",
            countryFilterText: "",
            showSearchCountryPopup: false,
            country: "",
            request: {
                utm_source: utmSource,
                utm_medium: utmMedium,
                utm_campaign: utmCampaign,
                requestSource: requestSource,
                requestType: "TraqadeFreeTrial",
                name: "",
                email: "",
                mobile: "",
                op_city: "",
                op_gym: "",
                op_message: "",
                country: "",
            },
        };
    },
    mounted: function() {
        this.request = {
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign,
            requestSource: requestSource,
            requestType: "TraqadeFreeTrial",
            name: "",
            email: "",
            mobile: "",
            op_city: "",
            op_gym: "",
            op_message: "",
        };
        this.getCountryData();
    },
    methods: {
        openCountrySelectionPopup: function() {
            this.showSearchCountryPopup = true;
            this.$nextTick(function() {
                if (this.$refs.filterTextInputRef) {
                    this.$refs.filterTextInputRef.focus();
                }
            });
        },
        closeCountrySelectionPopup: function() {
            this.showSearchCountryPopup = false;
        },
        setCountry: function(country) {
            if (country) {
                this.country = `+${country.callingCodes[0]}`;
                this.countryFlagUrl = country.flag;
            }
            this.showSearchCountryPopup = false;
        },
        filterCountries: function() {
            if (this.countryFilterText) {
                this.filterCountryList = this.countryList.filter((country) => {
                    return country.name
                        .toLowerCase()
                        .includes(this.countryFilterText.toLowerCase());
                });
            } else this.filterList = [...this.countryList];
        },
        getCountryData: function() {
            fetch(
                "https://restcountries.com/v2/all?fields=name,callingCodes,flag"
            )
                .then((response) => response.json())
                .then((data) => {
                    this.countryList = data;
                    this.filterCountryList = data;
                });
        },
        createUserRequest: function(formName) {
            var requestObj = { ...this.request };
            if (formName === undefined) {
                var isValid = validate.formIsValid("popupForm", true);
                requestObj.requestSource = requestSource;
                requestObj.mobile = this.country + this.request.mobile;
                var reqLoader = Ladda.create(
                    document.querySelector(".traqadeSubmitBtnLoader")
                );
            } else {
                var isValid = validate.formIsValid(formName, true);
                requestObj.requestSource = `${requestSource}-${formName}`;
                requestObj.mobile = this.country + this.request.mobile;
                var reqLoader = Ladda.create(
                    document.querySelector(".traqadeSubmitBtnLoader2")
                );
            }
            if (!isValid) {
                return false;
            }
            reqLoader.start();

            this.$http.post("/api/traqade/request", requestObj).then(
                (response) => {
                    if (response.body.hasError) {
                        this.errorMessage = "Something went wrong";
                        toastr["error"]("Something went wrong!", "FAILED!");
                        return false;
                    }
                    // toastr["success"](response.body.message);
                    this.request = {
                        utm_source: utmSource,
                        utm_medium: utmMedium,
                        utm_campaign: utmCampaign,
                        requestSource: requestSource,
                        requestType: "TraqadeFreeTrial",
                        name: "",
                        email: "",
                        mobile: "",
                        op_city: "",
                        op_gym: "",
                        op_message: "",
                    };
                    this.countryFlagUrl = "";
                    this.countryFilterText = "";
                    this.showSearchCountryPopup = false;
                    this.country = "";
                    reqLoader.stop();
                    reqLoader.remove();
                    $("#traqade-contact").modal("hide");
                    window.location.href = "/thank-you";
                    // $("#request-success").modal("show");
                },
                (response) => {
                    reqLoader.stop();
                    reqLoader.remove();
                    this.errorMessage = "Something went wrong!";
                    toastr["error"]("Something went wrong!", "Failed");
                }
            );
        },
    },
};

new Vue({
    el: "#traqade-contact",
    mixins: [reqDemo],
});

new Vue({
    el: "#reqDemoSection",
    mixins: [reqDemo],
});

$(".contact-mail-text").hide();
var urlParams = new URLSearchParams(window.location.search);
if (urlParams.has("source")) {
    $(".hide-in-app").hide();
    $(".contact-mail-link").hide();
    $(".contact-mail-text").show();
}

// Cookie for Merger Popup

function setCookie(cname, cvalue, exptime) {
    var d = new Date();
    d.setTime(d.getTime() + exptime);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// window.setTimeout(function() {
//     if ($("#OnAdPopup").length && getCookie("ON-AD-POPUP") != "ON-AD-POPUP") {
//         $("#OnAdPopup").modal("show");
//         var exptime = 15 * 60 * 1000;
//         setCookie("ON-AD-POPUP", "ON-AD-POPUP", exptime);
//     }
// }, 2000);
